import { Locales } from '@griply/types';

// Localizes build-time curated UI content keyed by full `Locales` (4 languages,
// region fallback). Firestore-persisted 2-language domain strings (life-area /
// metric names) use `getLocalizedStringValue` + `LocalizedString` instead.
export type LocalizedText =
  | string
  | ({ [Locales.EnUS]: string } & Partial<Record<Locales, string>>);

const baseLanguage = (tag: string): string => tag.split('-')[0];

export const resolveLocalized = (
  text: LocalizedText,
  language: string,
): string => {
  if (typeof text === 'string') {
    return text;
  }

  const exact = text[language as Locales];
  if (exact) {
    return exact;
  }

  const base = baseLanguage(language);
  const baseMatch = Object.entries(text).find(
    ([locale]) => baseLanguage(locale) === base,
  );

  return baseMatch?.[1] ?? text[Locales.EnUS];
};
